import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import firebase from 'firebase/app'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

  routes: [
    {
      path: '/',
      name: 'top',
      component: () => import('./views/Top.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('./views/Privacy.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/notices',
      name: 'notices',
      component: () => import('./views/Notices.vue')
    },
    {
      path: '/notice/:id',
      name: 'notice',
      component: () => import('./views/Notice.vue')
    },
    {
      path: '/articles',
      name: 'articles',
      component: () => import('./views/Articles.vue')
    },
    {
      path: '/en/articles',
      name: 'articlesEn',
      component: () => import('./views/ArticlesEn.vue')
    },
    {
      path: '/en/article/:id',
      name: 'articleEn',
      component: () => import('./views/ArticleEn.vue')
    },
    {
      path: '/article/:id',
      name: 'article',
      component: () => import('./views/Article.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('./views/Home.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/archive',
      name: 'archive',
      component: () => import('./views/Archive.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/write',
      name: 'write',
      component: () => import('./views/Write.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/like',
      name: 'like',
      component: () => import('./views/Like.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/translate_result/:id',
      name: 'translate_result',
      component: () => import('./views/TranslateResult.vue'),
      meta: { requiresAuth: true }
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
      firebase.auth().onAuthStateChanged(function(user) {
        if (!user) {
          next({
            path: '/',
          })
        } else {
          store.commit('onAuthStateChanged', user);
          store.commit('onUserStatusChanged', user.uid ? true : false);
          next()
        }
    });
  }else{
    next()
  }
})

export default router
